import Entity from '@/models/entities/Entity';
import { ColorGroup } from '@/models/entities/ColorGroup';

export class Color implements Entity {
  public id: number = 0;
  public name: string = '';
  public value: string = '';
  public position: number = 0;
  public colorGroups: ColorGroup[] = [];

  constructor(initData: Partial<Color>) {
    Object.assign(this, initData);
  }
}
